import React, { useState } from 'react';

interface FooterProps {
  sortBy?: string;
}

export default function Footer({ sortBy }: FooterProps) {
  const isUtilityFilter = sortBy === 'utility';
  const [showAbout, setShowAbout] = useState(false);

  return (
    <footer className="mt-16 mb-6">
      <div className="bg-gradient-to-br from-bg-secondary to-bg-tertiary rounded-3xl p-6 shadow-bubble border-2 border-primary/10">
        <div className="text-center">
          {isUtilityFilter && (
            <p className="text-primary text-lg font-bold mb-3 bg-gradient-to-r from-primary to-purple-500 bg-clip-text text-transparent">
              The Real Bitcoin.
            </p>
          )}
          
          <button
            onClick={() => setShowAbout(!showAbout)}
            className="text-text-secondary text-sm font-medium mb-3 hover:text-primary transition-colors duration-300 underline cursor-pointer"
          >
            {showAbout ? 'Hide' : 'About this website'}
          </button>

          {showAbout && (
            <div className="mb-6 max-w-2xl mx-auto text-left bg-bg/50 rounded-2xl p-6 border-2 border-border">
              <h3 className="text-xl font-bold mb-3 bg-gradient-to-r from-primary to-purple-500 bg-clip-text text-transparent">
                🔭 About CryptoScope
              </h3>
              <p className="text-text-secondary text-sm mb-3 leading-relaxed">
                CryptoScope is a modern cryptocurrency tracker focused on Bitcoin (BSV) utility. Track real-time prices for 1000+ cryptocurrencies, manage your portfolio, and access advanced analytics powered by BSV micropayments.
              </p>
              <p className="text-text-secondary text-sm mb-3 leading-relaxed">
                <strong className="text-text">Features:</strong> Real-time market data, portfolio management, price alerts, advanced analytics, price comparisons, and export functionality. All powered by BSV blockchain micropayments—no ads, no subscriptions.
              </p>
              <p className="text-text-secondary text-sm leading-relaxed">
                Built with the goal of educating users about the real Bitcoin (BSV) while providing professional-grade portfolio management tools. Connect your BSV wallet to unlock premium features!
              </p>
            </div>
          )}

          <div className="flex flex-col gap-2 items-center">
            <p className="text-text-secondary text-sm font-medium">
              Created with 💙 by{' '}
              <a
                href="https://github.com/casuality3"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary font-bold bg-gradient-to-r from-primary to-purple-500 bg-clip-text text-transparent hover:underline transition-all duration-300"
              >
                Casuality
              </a>
            </p>
            <a
              href="https://bitcoin.org/bitcoin.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-secondary text-sm font-medium hover:text-primary transition-colors duration-300 underline"
            >
              📜 Bitcoin Whitepaper
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

